// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faHeadphones,
//   faReceipt,
//   faFileImport,
//   faFileAlt,
//   faClipboardList,
//   faTrashAlt,
//   faFileSignature,
//   faChartBar,
//   faRetweet,
//   faCamera,
//   faChevronDown,
//   faChevronRight,
//   faBars,
//   faArrowAltCircleRight,
//   faArrowRightArrowLeft,
//   faArrowRight,
// } from "@fortawesome/free-solid-svg-icons";
// import { Link } from "react-router-dom";
// import BankFileModal from "../Modal/BankFileModal";
// import API_BASE_URL from "../utilities/ApiConfig";
// import axios from "axios";
// import { ArrowRight } from "@mui/icons-material";

// const SideMenuHOD = () => {
//   const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
//   const [isModificationOpen, setIsModificationOpen] = useState(false);
//   const [isCompulsoryMarriageOpen, setIsCompulsoryMarriageOpen] =
//     useState(false);
//   const [isScanningOpen, setIsScanningOpen] = useState(false);
//   const [isEditOpen, setIsEditOpen] = useState(false);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isBankFileModalOpen, setIsBankFileModalOpen] = useState(false);
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

//   const toggleRegistrationMenu = () => {
//     setIsRegistrationOpen(!isRegistrationOpen);
//   };

//   const toggleScanningMenu = () => {
//     setIsScanningOpen(!isScanningOpen);
//   };

//   const toggleEditMenu = () => {
//     setIsEditOpen(!isEditOpen);
//   };

//   const toggleModificationMenu = () => {
//     setIsModificationOpen(!isModificationOpen);
//   };

//   const toggleCompulsoryMarriageMenu = () => {
//     setIsCompulsoryMarriageOpen(!isCompulsoryMarriageOpen);
//   };

//   const toggleSidebar = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleBankFileModal = () => {
//     setIsBankFileModalOpen(true);
//   };

//   // const handleBankFileModal = async () => {
//   //   try {
//   //     const response = await axios.get(
//   //       `${API_BASE_URL}/Registration/getDeedNames?mode=BANKFILE`
//   //     );
//   //     console.log("Deed Names Data:", response.data); // Handle response data as needed
//   //     setIsBankFileModalOpen(true);
//   //   } catch (error) {
//   //     console.error("Error fetching deed names:", error);
//   //   }
//   // };

//   const handleResize = () => {
//     setIsMobileView(window.innerWidth <= 768);
//   };

//   React.useEffect(() => {
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div>
//       <div
//         className={`md:block ${isMenuOpen ? "block" : "block"} min-h-full`}
//         style={{
//           backgroundColor: "#4F9CF9",
//           color: "white",
//           width: isMobileView ? "60px" : "230px",
//           padding: "0px",
//         }}
//       >
//         <Link
//           to="/DashboardAIG"
//           style={{ marginBottom: "30px", padding: "10px" }}
//         >
//           {!isMobileView && (
//             <>
//               <h2
//                 style={{ color: "white" }}
//                 className="text-2xl font-bold ps-2"
//               >
//                 CRS
//               </h2>
//               <p className="ps-2" style={{ color: "white" }}>
//                 Core Registration System
//               </p>
//             </>
//           )}
//         </Link>

//         {!isMobileView && (
//           <h3
//             style={{ color: "white" }}
//             className="text-lg font-bold mb-1 border-b px-10 un "
//           >
//             MENU
//           </h3>
//         )}
//         <ul style={{ listStyle: "none", padding: 0 }}>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Today Details"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Current Financial Year"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link
//               to="/ComparisonData"
//               style={{ color: "white", textDecoration: "none" }}
//             >
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Comparision Data"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Income Summary"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Top Deeds"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "ACIR Deeds"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Value Range Deeds"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Challan Details"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Exampler Details"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Tehsil Registry"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link
//               to="/PowerRegularizationAIGAction"
//               style={{ color: "white", textDecoration: "none" }}
//             >
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Regularization Request"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link
//               to="/UserCreation"
//               style={{ color: "white", textDecoration: "none" }}
//             >
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "User Creation"}
//             </Link>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default SideMenuHOD;

// src/components/SideMenuHOD.jsx

// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faHeadphones,
//   faReceipt,
//   faFileImport,
//   faFileAlt,
//   faClipboardList,
//   faTrashAlt,
//   faFileSignature,
//   faChartBar,
//   faRetweet,
//   faCamera,
//   faChevronDown,
//   faChevronRight,
//   faBars,
//   faArrowAltCircleRight,
//   faArrowRightArrowLeft,
//   faArrowRight,
// } from "@fortawesome/free-solid-svg-icons";
// import { Link } from "react-router-dom";
// import BankFileModal from "../Modal/BankFileModal";
// import API_BASE_URL from "../utilities/ApiConfig";
// import axios from "axios";
// import { ArrowRight } from "@mui/icons-material";

// const SideMenuHOD = () => {
//   const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
//   const [isModificationOpen, setIsModificationOpen] = useState(false);
//   const [isCompulsoryMarriageOpen, setIsCompulsoryMarriageOpen] =
//     useState(false);
//   const [isScanningOpen, setIsScanningOpen] = useState(false);
//   const [isEditOpen, setIsEditOpen] = useState(false);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isBankFileModalOpen, setIsBankFileModalOpen] = useState(false);
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

//   const toggleRegistrationMenu = () =>
//     setIsRegistrationOpen(!isRegistrationOpen);
//   const toggleScanningMenu = () => setIsScanningOpen(!isScanningOpen);
//   const toggleEditMenu = () => setIsEditOpen(!isEditOpen);
//   const toggleModificationMenu = () =>
//     setIsModificationOpen(!isModificationOpen);
//   const toggleCompulsoryMarriageMenu = () =>
//     setIsCompulsoryMarriageOpen(!isCompulsoryMarriageOpen);

//   const toggleSidebar = () => setIsMenuOpen(!isMenuOpen);
//   const handleBankFileModal = () => setIsBankFileModalOpen(true);

//   const handleResize = () => setIsMobileView(window.innerWidth <= 768);
//   React.useEffect(() => {
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div>
//       <div
//         className={`md:block ${
//           isMobileView ? (isMenuOpen ? "block" : "hidden") : "block"
//         } min-h-full`}
//         style={{
//           backgroundColor: "#4F9CF9",
//           color: "white",
//           width: isMobileView ? "60px" : "230px",
//           padding: "0px",
//           borderTopRightRadius: "20px",
//           borderBottomRightRadius: "20px",
//           overflowY: "auto",
//         }}
//       >
//         {/* Hamburger toggle (mobile only) */}
//         {isMobileView && (
//           <div className="flex justify-end p-2">
//             <FontAwesomeIcon
//               icon={faBars}
//               onClick={toggleSidebar}
//               className="text-white text-xl"
//             />
//           </div>
//         )}

//         <Link
//           to="/DashboardAIG"
//           style={{ marginBottom: "30px", padding: "10px" }}
//         >
//           {!isMobileView && (
//             <>
//               <h2
//                 style={{ color: "white" }}
//                 className="text-2xl font-bold ps-2"
//               >
//                 CRS
//               </h2>
//               <p className="ps-2" style={{ color: "white" }}>
//                 Core Registration System
//               </p>
//             </>
//           )}
//         </Link>

//         {!isMobileView && (
//           <h3
//             style={{ color: "white" }}
//             className="text-lg font-bold mb-1 border-b px-10 un"
//           >
//             MENU
//           </h3>
//         )}

//         <ul style={{ listStyle: "none", padding: 0 }}>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Today Details"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Current Financial Year"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link
//               to="/ComparisonData"
//               style={{ color: "white", textDecoration: "none" }}
//             >
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Comparision Data"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Income Summary"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Top Deeds"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "ACIR Deeds"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Value Range Deeds"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Challan Details"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Exampler Details"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link to="/" style={{ color: "white", textDecoration: "none" }}>
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Tehsil Registry"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link
//               to="/PowerRegularizationAIGAction"
//               style={{ color: "white", textDecoration: "none" }}
//             >
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "Regularization Request"}
//             </Link>
//           </li>
//           <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
//             <Link
//               to="/UserCreation"
//               style={{ color: "white", textDecoration: "none" }}
//             >
//               <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//               {!isMobileView && "User Creation"}
//             </Link>
//           </li>
//         </ul>
//       </div>

//       {isBankFileModalOpen && (
//         <BankFileModal onClose={() => setIsBankFileModalOpen(false)} />
//       )}
//     </div>
//   );
// };

// export default SideMenuHOD;

// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faHeadphones,
//   faReceipt,
//   faFileImport,
//   faFileAlt,
//   faClipboardList,
//   faTrashAlt,
//   faFileSignature,
//   faChartBar,
//   faRetweet,
//   faCamera,
//   faChevronDown,
//   faChevronRight,
//   faArrowRight,
// } from "@fortawesome/free-solid-svg-icons";
// import { faBars } from "@fortawesome/free-solid-svg-icons";
// import { Link } from "react-router-dom";
// import BankFileModal from "../Modal/BankFileModal";

// const SideMenuHOD = ({ isOpen, onClose }) => {
//   const [isBankFileModalOpen, setIsBankFileModalOpen] = useState(false);

//   return (
//     <>
//       {/* <div
//         className={`md:block ${isOpen ? "block" : "hidden"} min-h-full`}
//         style={{
//           backgroundColor: "#4F9CF9",
//           color: "white",
//           width: "230px",
//           padding: "0px",
//           borderTopRightRadius: "20px",
//           borderBottomRightRadius: "20px",
//           overflowY: "auto",
//         }}
//       > */}

//       <div
//         className={`
//     fixed top-0 left-0 h-full z-50
//     bg-blue-500 text-white w-56 overflow-y-auto
//     rounded-tr-2xl rounded-br-2xl

//     transform transition-transform duration-200 ease-in-out
//     ${isOpen ? "translate-x-0" : "-translate-x-full"}

//     md:static        /* position back to normal flow on md+ */
//     md:translate-x-0 /* no slide-off on md+ */
//     md:block         /* always visible on md+ */
//   `}
//       >
//         {/* close button on mobile */}
//         <div className="md:hidden flex justify-end p-2">
//           <FontAwesomeIcon
//             icon={faChevronRight}
//             className="text-white text-xl"
//             onClick={onClose}
//           />
//         </div>

//         <Link
//           to="/DashboardAIG"
//           style={{ marginBottom: "30px", padding: "10px" }}
//         >
//           <h2 style={{ color: "white" }} className="text-2xl font-bold ps-2">
//             CRS
//           </h2>
//           <p className="ps-2" style={{ color: "white" }}>
//             Core Registration System
//           </p>
//         </Link>

//         <h3
//           style={{ color: "white" }}
//           className="text-lg font-bold mb-1 border-b px-10 un"
//         >
//           MENU
//         </h3>

//         <ul style={{ listStyle: "none", padding: 0 }}>
//           {[
//             { to: "/", label: "Today Details" },
//             { to: "/", label: "Current Financial Year" },
//             { to: "/ComparisonData", label: "Comparision Data" },
//             { to: "/IncomeSummary", label: "Income Summary" },
//             { to: "/TopDeeds", label: "Top Deeds" },
//             { to: "/ACIRDeeds", label: "ACIR Deeds" },
//             { to: "/ValueRangeDeeds", label: "Value Range Deeds" },
//             { to: "/ChallanDetails", label: "Challan Details" },
//             { to: "/ExamplerDetails", label: "Exampler Details" },
//             { to: "/TehsilRegistry", label: "Tehsil Registry" },
//             { to: "/AgriNonAgriExampler", label: "Agri Non Agri Exampler" },
//             {
//               to: "/SROWiseLocationExamplerAndTotalDoc",
//               label: "SRO Wise Location Exampler And Total Doc",
//             },
//             { to: "/SpotInspection", label: "Spot Inspection" },
//             {
//               to: "/DistrictDeedWiseReport",
//               label: "District DeedWise Report",
//             },
//             {
//               to: "/PrithuReport",
//               label: "Prithu Report",
//             },
//             {
//               to: "/ScanningReport",
//               label: "Scanning Report",
//             },
//             {
//               to: "/ParganaWiseReport",
//               label: "ParganaWise Report",
//             },
//             {
//               to: "/PowerRegularizationAIGAction",
//               label: "Regularization Request",
//             },
//             { to: "/UserCreation", label: "User Creation" },
//           ].map(({ to, label }) => (
//             <li
//               key={label}
//               className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2"
//             >
//               <Link to={to} style={{ color: "white", textDecoration: "none" }}>
//                 <FontAwesomeIcon icon={faArrowRight} className="me-2" />
//                 {label}
//               </Link>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {isBankFileModalOpen && (
//         <BankFileModal onClose={() => setIsBankFileModalOpen(false)} />
//       )}
//     </>
//   );
// };

// export default SideMenuHOD;

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import BankFileModal from "../Modal/BankFileModal";

const SideMenuHOD = ({ isOpen, onClose }) => {
  const [isBankFileModalOpen, setIsBankFileModalOpen] = useState(false);

  const menuItems = [
    { to: "/", label: "Today Details" },
    { to: "/", label: "Current Financial Year" },
    { to: "/ComparisonData", label: "Comparision Data" },
    { to: "/IncomeSummary", label: "Income Summary" },
    { to: "/TopDeeds", label: "Top Deeds" },
    { to: "/ACIRDeeds", label: "ACIR Deeds" },
    { to: "/ValueRangeDeeds", label: "Value Range Deeds" },
    { to: "/ChallanDetails", label: "Challan Details" },
    { to: "/ExamplerDetails", label: "Exampler Details" },
    { to: "/TehsilRegistry", label: "Tehsil Registry" },
    { to: "/AgriNonAgriExampler", label: "Agri Non Agri Exampler" },
    {
      to: "/SROWiseLocationExamplerAndTotalDoc",
      label: "SRO Wise Location Exampler And Total Doc",
    },
    { to: "/SpotInspection", label: "Spot Inspection" },
    {
      to: "/DistrictDeedWiseReport",
      label: "District DeedWise Report",
    },
    { to: "/PrithuReport", label: "Prithu Report" },
    { to: "/ScanningReport", label: "Scanning Report" },
    { to: "/ParganaWiseReport", label: "ParganaWise Report" },
    { to: "/TotalDocRevReport", label: "Total Doc Rev" },
    {
      to: "/DistrictLocationExamplerReport",
      label: "District Location Exampler",
    },
    {
      to: "/PowerRegularizationAIGAction",
      label: "Regularization Request",
    },
    { to: "/UserCreation", label: "User Creation" },
  ];

  return (
    <>
      <div
        className={`
          fixed top-0 left-0 h-full z-50
          bg-[#4F9CF9] text-white w-[230px]
          rounded-tr-[20px] rounded-br-[20px]
          transform transition-transform duration-200 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          md:static md:translate-x-0 md:block
          overflow-hidden
        `}
      >
        {/* inner scrollable area */}
        <div className="h-full overflow-y-auto">
          {/* close button on mobile */}
          <div className="md:hidden flex justify-end p-2">
            <FontAwesomeIcon
              icon={faChevronRight}
              className="text-white text-xl cursor-pointer"
              onClick={onClose}
            />
          </div>

          {/* Logo / Title */}
          {/* <Link to="/DashboardAIG" className="block mb-8 px-4">
            <h2 className="text-2xl font-bold">CRS</h2>
            <p className="text-sm">Core Registration System</p>
          </Link> */}

          <Link
            to="/DashboardAIG"
            style={{ marginBottom: "30px", padding: "10px" }}
          >
            <h2 style={{ color: "white" }} className="text-2xl font-bold ps-2">
              CRS
            </h2>
            <p className="ps-2" style={{ color: "white" }}>
              Core Registration System
            </p>
          </Link>

          {/* Menu header */}
          {/* <h3 className="text-lg font-bold mb-4 border-b px-4">MENU</h3> */}
          <h3
            style={{ color: "white" }}
            className="text-lg font-bold mb-1 border-b px-10 un"
          >
            MENU
          </h3>

          {/* Menu items */}
          <ul style={{ listStyle: "none", padding: 0 }}>
            {menuItems.map(({ to, label }) => (
              <li
                key={label}
                className="border-b hover:bg-blue-600 hover:rounded p-2"
              >
                <Link
                  to={to}
                  style={{ color: "white", textDecoration: "none" }}
                  className="flex items-center space-x-2 no-underline"
                >
                  <FontAwesomeIcon icon={faArrowRight} />
                  <span>{label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Optional modal */}
      {isBankFileModalOpen && (
        <BankFileModal onClose={() => setIsBankFileModalOpen(false)} />
      )}
    </>
  );
};

export default SideMenuHOD;
